module.exports = __webpack_public_path__ + "img/pic4.77e421b2.jpeg";